import PropTypes from 'prop-types';
import React from 'react';
import { Button } from 'react-bootstrap';
import { connect } from 'react-redux';
import { LinkContainer } from 'react-router-bootstrap';
import { userId } from '../../../reducers/currentUser/currentUser.reducer';
import { loadForProjectManager } from '../../../reducers/workOrder/workOrders.actions';
import { loading, approvedWorkOrders } from '../../../reducers/workOrder/workOrders.reducer';
import { Spinner } from '../../Spinner/Spinner';
import WorkOrderList from '../../WorkOrderList/WorkOrderList';
import './ProjectManagerHistory.css';

// eslint-disable-next-line object-curly-newline
export class ProjectManagerHistory extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <LinkContainer to="/pm/workorders/new" >
          <Button className="pull-right" bsStyle="primary" >Create New DWR</Button>
        </LinkContainer>
        <br />
        {this.props.loading && <Spinner isLoading /> }
        <WorkOrderList workOrders={this.props.workOrders} url="/pm" />
      </span>
    );
  }
}

ProjectManagerHistory.propTypes = {
  load: PropTypes.func.isRequired,
  workOrders: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  loading: PropTypes.bool.isRequired,
};

export const mapStateToProps = state => ({
  workOrders: approvedWorkOrders(state),
  loading: loading(state),
  id: userId(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(loadForProjectManager()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProjectManagerHistory);



// WEBPACK FOOTER //
// ./src/components/ProjectManager/History/ProjectManagerHistory.jsx